import { type Banner, Res } from '@/types'

import base from './base'

export const bannerApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getBanners: builder.query<Banner[], void>({
      query: () => 'teachers/banners',
      transformResponse: (res: Res<Banner[]>) => res.data,
      providesTags: ['Banners'],
    }),
  }),
})

export const { useGetBannersQuery } = bannerApi
